import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ViewEncapsulation } from '@angular/core'
import { ApiService } from '@service/api/api.service';
import { MealAudienceCategory } from '@interface/mealaudiencecategory.interface';

@Component({
  selector: 'app-audience-view',
  templateUrl: './audience-view.component.html',
  styleUrls: ['./audience-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AudienceViewComponent implements OnInit {

  public constructor(
    private titleService: Title,
    private meta: Meta,
    private route: ActivatedRoute,
    protected http: HttpClient,
    public api: ApiService

  ) {
    this.titleService.setTitle('M|Catering - Michigan Catering Menu')
    this.meta.updateTag({
      name: 'description',
      content: 'View the Michigan Catering menu and choose from a diverse selection of fresh, authentic foods for on- or off-campus events like weddings, special events, and more.'
    });
    this.meta.updateTag({
      name: 'og:title',
      content: 'Michigan Catering Menu'
    });
    this.meta.updateTag({
      name: 'og:description',
      content: 'View the Michigan Catering menu and choose from a diverse selection of fresh, authentic foods for on- or off-campus events like weddings, special events, and more.'
    });
  }

  id$ = this.route.snapshot.paramMap.get('id') || '';
  mealsets$:Observable<MealAudienceCategory[]> = new Observable();
  dataSet:any[] = [];
  toggleAllOpen:boolean = false;
  ngOnInit(): void {
    if(this.id$ !== '') {
      this.mealsets$ = this.route.data.pipe(
        map((data:any) => {
          return data.data['hydra:member'];
        }),
        map((data:any) => {
          const newData = data.map((e:any) => {
              e.mealSets = e.mealSets.map((b:any) =>{
                b['@id'] = this.api.getId(b['@id']);
                return b;
              })
              return e;
          })
          return this.dataSet = data;
        })
      );
    }
  }

  addOpen(data:any) {
    data.forEach((element:any) => {
      element['open'] = false;
    });
    return data;
  }
  goToMenu() {
    window.location.href="/menu";
  }
  print() {
    window.print();
  }
  toggleOpen() {
    if(this.toggleAllOpen) {
      this.toggleAllOpen = false;
    } else {
      this.toggleAllOpen = true;
    }
  }
  
  buildSidebar(data:any):any[] {
    let dataSet:any[] = [];
    let counter = 0;
    data.forEach((e:any) => {
      e.id = counter;
      let index = dataSet.findIndex((x:any) => {
        return x.name === e.category
      });
      if(index !== -1) {
        dataSet[index].data.push(e);
      } else {
        dataSet.push(
          {
            name: e.category,
            data: [e],
            open: false
          }
        )
      }
      counter++;
    })
    return dataSet;
  }
  toggleMenu(data:number):void {
    if(this.dataSet[data].open) {
      this.dataSet[data].open = false;
    } else {
      this.dataSet[data].open = true;
    }
  }
}
